import { render } from "./AppCustomSelect.vue?vue&type=template&id=c08a183a"
import script from "./AppCustomSelect.vue?vue&type=script&lang=js"
export * from "./AppCustomSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__